import { ExpandMore as MuiExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React from 'react';

import themeConstants from '../../../common/constants/Theme';

const useStyles = makeStyles((theme) =>
    createStyles({
        accordion: {
            backgroundColor: '#FFFFFF !important',
            marginBottom: '20px',
            padding: '0 5px',
            boxShadow: "none !important",
            '&:before': {
                height: '0 !important'
            },
        },
        accordionSummaryTypography: {
            color: themeConstants.GREY,
            fontSize: '20px'
        },
        summary: {
            padding: '0 15px !important',
            backgroundColor: theme.palette.background.paper + ' !important',
            minHeight: '64px !important',
            '& .MuiAccordionSummary-content': {
                margin: '12px !important'
            }
        },
        count: {
            position: 'absolute',
            right: 80,
            lineHeight: '38px'
        }
    }),
);

const BatchLoadAccordion = (props) => {
    const classes = useStyles();
    return (
        <Accordion className={classes.accordion} {...props}>
            <AccordionSummary className={classes.summary} expandIcon={<MuiExpandMore sx={{ color: '#0E70FF' }} />}>
                <Box className={classes.count}>{props.count} files</Box>
                {props.icon}
                <Typography
                    variant='h5'
                    className={classes.accordionSummaryTypography}
                >
                    {props.label}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </Accordion>
    );
};

export default BatchLoadAccordion;
